module.exports = __webpack_public_path__ + "static/media/scene-color.e364851a.svg";